import ForumIcon from '@mui/icons-material/Forum';
import { Box, MenuItem } from '@mui/material';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { useProductsByLocation } from 'apps/wrapper/src/hooks/use-products-by-location';
import { EventInboxCommunicationsWidget, EventJumpToMessage } from 'apps/wrapper/src/types/event-bus';
import { FC, useCallback } from 'react';
import { PatientActionsContact } from '../types/patient-info';

export interface MessengerActionProps {
  onClose: () => void;
  contact?: PatientActionsContact;
  onMessengerClick?: (patientId: number) => void;
  locationId: number;
}

export const MessengerAction: FC<MessengerActionProps> = (props) => {
  const { contact, locationId, onMessengerClick, onClose } = props;
  const { hasProduct } = useProductsByLocation(locationId);
  const { publish } = useEventBus();

  const isCellPhoneValid = useCallback(() => {
    return contact?.cellPhone && contact?.cellPhone.length > 0;
  }, [contact]);

  const handleMessengerClick = useCallback(() => {
    if (!contact) {
      onClose();
      return;
    }

    if (onMessengerClick && contact?.id) {
      onMessengerClick(contact.id);
    } else if (hasProduct('messenger') && contact?.id) {
      publish({
        messageType: 'jumpToMessage',
        data: {
          patientId: contact.id
        } as EventJumpToMessage['data']
      });
    } else if (hasProduct('messenger2') && (contact.id || contact.location?.id)) {
      publish({
        messageType: 'inboxCommunications',
        data: {
          phoneNumber: contact.cellPhone,
          locationId: contact.location?.id,
          patientId: contact.id
        } as EventInboxCommunicationsWidget['data']
      });
    } else {
      console.error('No handler for the Messenger click event.');
    }

    onClose();
  }, [contact]);

  if (
    contact &&
    isCellPhoneValid() &&
    (contact.id || contact.location?.id) &&
    (hasProduct('messenger') || hasProduct('messenger2'))
  )
    return (
      <MenuItem onClick={handleMessengerClick}>
        <ForumIcon color="primary" />
        <Box sx={{ margin: '0 20px 0 10px' }}>Text</Box>
      </MenuItem>
    );
  else return null;
};
